export { ConsentBanner } from './ui/consent-banner';
export { PreferenceModal } from './ui/consent-banner/preference-modal';

export {
	setCookie,
	setStrictlyNecessaryCookie,
	getCookie,
	deleteCookie,
	initializeControls,
	unpackUserPreferencesCookie,
} from './controllers/cookie-controls';
export type { JSCookieAttributes } from './controllers/cookie-controls';
export { checkThirdParty } from './controllers/third-party-controls';
export { shouldRenderBanner, shouldRenderBannerPrefetched } from './controllers/banner-controls';
export { getPreferences } from './controllers/preferences-controls/get-preferences';
export {
	LEGACY_ATLASSIAN_GDPR_COOKIE_KEY,
	ATLASSIAN_CONSENT_COOKIE_KEY,
	ATLASSIAN_SHOW_BANNER_COOKIE_KEY,
	ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY,
	ATLASSIAN_CURRENT_LOCALE_COOKIE_KEY,
} from './constants';

export type {
	ConsentHubResponse,
	PrefetchedConsentPreferences,
} from './services/consent-hub-service/types';
export type { PrefetchedConsentPreferenceData } from './controllers/banner-controls/types';
export { Status } from './controllers/cookie-controls/set-cookie/types';
export { PrefetchedPreferenceState } from './types';
export { AtlBrowserStorageSession, AtlBrowserStorageLocal } from './services/web-storage-service';
export type { CategorizedStorageControlsCache, CategoryStorageType } from './types';
export { PreferenceCategory } from './types';
export { serializeConsents } from './services/consent-hub-service/utils';
export { AtlIndexedDb, atlIndexedDb } from './services/indexed-db-wrapper-service';
export type {
	AtlIndexedDbConfig,
	AtlIndexedDbFactory,
	isIndexedDbDatabaseAllowed,
} from './services/indexed-db-wrapper-service';
export { getItemCategoryFromPassedCache } from './common/utils/item-processing';
export { getCategoryCacheUrlPerimeterSSR } from './common/utils/load-storage-controls-data/constants';
